import React from 'react';
import { CheckIcon, AudioWaveLoadingIcon, ErrorIcon } from '../../icons';
import { SyncStatus } from '../../types';

interface SyncStatusIndicatorProps {
  syncStatus: SyncStatus;
}

const STATUS_CONFIG = {
  synced: {
    color: 'text-green-600 dark:text-green-400',
    icon: <CheckIcon size={16} className="text-green-500" />,
    getText: (_count: number) => 'Saved',
  },
  pending: {
    color: 'text-blue-600 dark:text-blue-400',
    icon: <AudioWaveLoadingIcon size={16} className="text-blue-500" />,
    getText: (count: number) => `Saving${count > 0 ? ` (${count})` : ''}`,
  },
  error: {
    color: 'text-red-600 dark:text-red-400',
    icon: <ErrorIcon size={16} className="text-red-500" />,
    getText: (_count: number) => 'Save Error',
  },
} as const;

const SyncStatusIndicator: React.FC<SyncStatusIndicatorProps> = ({
  syncStatus,
}) => {
  const config = STATUS_CONFIG[syncStatus];

  return (
    <div className={`flex items-center space-x-2 text-xs ${config.color}`}>
      {config.icon}
    </div>
  );
};

export default SyncStatusIndicator;
